import {
    GROUPS_DATA,
    GROUPS_UPDATE_DATA,
    GROUPS_MEMBER_DATA,
    CURRENT_CALL_GROUP_MEMBERS,
    GROUPS_MEMBER_PARTICIPANTS_LIST_DATA,
    RECONNECT_GROUPS_UPDATE_DATA,
} from '../Actions/Constants';
import { GROUP_PROFILE_INFO_UPDATED } from '../Helpers/Chat/Constant';
const initialState = {
    groupParticipants: {},
};

const updateGroupDetails = (currentData, groupData = []) => {
    const dataToUpdate = Array.isArray(currentData) ? currentData : [currentData];
    let newGroupData = [...groupData];

    dataToUpdate.forEach(singleData => {
        const groupJid =
            singleData.groupJid ||
            (singleData.groupId ? `${singleData.groupId}@${singleData.chatType || 'groupchat'}` : null);
        const groupId = singleData.groupId || (singleData.groupJid ? singleData.groupJid.split('@')[0] : null);

        let index = newGroupData.findIndex(
            obj => (groupJid && groupJid.indexOf(obj.groupId) > -1) || (groupId && obj.groupId === groupId),
        );

        if (index > -1) {
            newGroupData[index] = {
                ...newGroupData[index],
                ...singleData,
                groupName: singleData.groupName || singleData.groupProfile?.nickName || newGroupData[index].groupName,
                isAdminBlocked:
                    singleData.isAdminBlocked !== undefined
                        ? singleData.isAdminBlocked
                        : newGroupData[index].isAdminBlocked,
            };
            if (singleData.msgType === GROUP_PROFILE_INFO_UPDATED) {
                newGroupData[index].groupImage = singleData.groupImage || singleData.groupProfile?.image || '';
                newGroupData[index].thumbImage = singleData.thumbImage || singleData.groupProfile?.thumbImage || '';
            }
            const disappear =
                singleData.msgDisappear !== undefined ? singleData.msgDisappear : singleData.groupProfile?.msgDisappear;
            if (disappear !== undefined) {
                newGroupData[index].msgDisappear = Number(disappear);
            }
        } else {
            newGroupData.push(singleData);
        }
    });

    return newGroupData;
};

const groupsInitialState = { id: null, data: [] };

export function GroupsReducer(state = groupsInitialState, action = {}) {
    const { id, data } = action.payload || {};
    switch (action.type) {
        case GROUPS_DATA:
            return action.payload;
        case GROUPS_UPDATE_DATA:
            return {
                ...state,
                id: id,
                data: updateGroupDetails(data, state.data || []),
            };
        case RECONNECT_GROUPS_UPDATE_DATA:
            return {
                ...state,
                id: id,
                data: [...(state.data || []), data],
            };
        default:
            return state;
    }
}

export function GroupsMemberListReducer(state = [], action = {}) {
    if (action.type === GROUPS_MEMBER_DATA) {
        return action.payload;
    }
    return state;
}

export function currentCallGroupMembersReducer(state = {}, action = {}) {
    if (action.type === CURRENT_CALL_GROUP_MEMBERS) {
        return action.payload;
    }
    return state;
}

export function GroupsMemberParticipantsListReducer(state = initialState, action = {}) {
    if (action.type === GROUPS_MEMBER_PARTICIPANTS_LIST_DATA) {
        let data = action.payload.data;
        let groupId = data.groupId;
        let participantsList = data.participantsList;
        let currentParticipantsList = { ...state.groupParticipants };
        currentParticipantsList[groupId] = participantsList;
        return {
            ...state,
            groupParticipants: currentParticipantsList,
        };
    } else {
        return state;
    }
}
